import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { type ModalName } from '@/modals-names';

import { type ModalsStore } from './types';

export const useModalsStateRaw = create<ModalsStore>()((set) => ({
  state: {},
  actions: {
    open: (name, props) => {
      set((prev) => {
        const index = Object.values(prev.state ?? {}).filter(
          ({ isOpen }) => isOpen
        ).length;

        return { state: { ...prev.state, [name]: { isOpen: true, index, props } } };
      });
    },
    close: (name) => {
      set((prev) => ({
        state: { ...prev.state, [name]: { ...prev.state[name], isOpen: false } },
      }));
    },
  },
}));

export const useModalsState = () => useModalsStateRaw(useShallow((store) => store.state));
export const useModalState = (name: ModalName) =>
  useModalsStateRaw(useShallow((store) => store.state[name] ?? {}));

export const useIsAnyModalOpened = () =>
  useModalsStateRaw(
    useShallow((store) => Object.values(store.state).some((modal) => modal.isOpen))
  );

export const useModalsActions = () => useModalsStateRaw((store) => store.actions);
